/* eslint-disable no-console */

import isError from "lodash/isError";

type LevelT = "error" | "info" | "log" | "debug";

export function logError(error: any, tag?: string, level: LevelT = "error"): void {
  tag = tag === undefined ? "" : `(${tag}): `;

  if (isError(error)) {
    log(level, `${tag}${error.message}\n${error.stack}`);
    return;
  }

  if (error != null && typeof error === "object") {
    try {
      log(level, tag + JSON.stringify(error));
      return;
    } catch {
      // Might fail because of cycle dependencies, and than will fallback to normal String casting
    }
  }

  log(level, tag + String(error));
}

function logErrorBound(tag: string, level?: LevelT): (error: any) => void {
  return function logErrorBounded(error: any): void {
    return logError(error, tag, level);
  };
}

logError.bound = logErrorBound;

function log(level: LevelT, message: string) {
  if (level === "error") {
    console.error(message);
  } else if (level === "info") {
    console.info(message);
  } else if (level === "log") {
    console.log(message);
  } else if (level === "debug") {
    console.debug(message);
  }
}
